<template>
  <div class="main">
    <ReSignIn v-if="!isLogin && !isStandalonePage" />

    <div
      class="main-content"
      :class="{ 'sign-in-content': isUseSignInSignUpLayout }"
    >
      <!-- Navbar -->
      <b-navbar
        v-if="!isPublicPage"
        :class="{
          notActive: isHideOnUsersPage,
          'navbar-sign-in': isUseSignInSignUpLayout,
        }"
        class="navbar-main"
        type="light"
      >
        <div
          class="d-flex w-100 justify-content-between align-items-center"
          v-if="!isLogin && isStandalonePage"
        >
          <div class="d-flex">
            <img
              :src="logoName"
              alt="Easy agency logo"
              :style="{ width: '116px' }"
              class="ml-5"
            />
          </div>
          <div class="sign-in-buttons">
            <b-button
              v-if="isSigninRoute"
              tag="a"
              :href="bookDemoHref"
              target="_blank"
              variant="light"
              size="lg"
              class="button"
            >
              Book Demo
            </b-button>
            <b-button
              tag="router-link"
              :to="{ name: ROUTES.SIGN_IN.name }"
              variant="light"
              size="lg"
              class="button"
            >
              Sign In
            </b-button>
            <b-button
              v-if="isSigninRoute"
              tag="a"
              :href="`//${appDomain}${ROUTES.SIGN_UP.path}`"
              variant="primary"
              size="lg"
              class="button"
            >
              Try it
            </b-button>
            <b-button
              v-else
              tag="a"
              :href="bookDemoHref"
              target="_blank"
              variant="primary"
              size="lg"
              class="button"
            >
              Book Demo
            </b-button>
          </div>
        </div>
        <PrimaryNavigation v-if="!isStandalonePage" :menu="menu" />
      </b-navbar>
      <div
        class="layout"
        :class="{ 'no-transition': temporarilyNoTransition }"
        :style="{
          marginLeft: showSecondaryNavigation
            ? isOpen
              ? '240px'
              : '55px'
            : '0px',
        }"
      >
        <SecondaryNavigation
          v-if="showSecondaryNavigation"
          :menu="menu"
          :isOpen="isOpen"
          @toggleMenu="toggleMenu"
        />
        <div class="content">
          <router-view></router-view>
        <portal-target :name="PostalNames.SlideOutContainer"></portal-target>
        <portal-target :name="PostalNames.SlideOutContainerLayer1"></portal-target>
        <portal-target :name="PostalNames.SlideOutContainerLayer2"></portal-target>
        <portal-target :name="PostalNames.SlideOutContainerLayer3"></portal-target>
        <portal-target :name="PostalNames.PreloaderOverlay"></portal-target>
        </div>
      </div>
    </div>

    <portal-target :name="PostalNames.InvoiceFormPopupOverlay"></portal-target>
    <vue-snotify></vue-snotify>
    <ConfirmModal ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isPublicPage, isSignInSignUpPage } from '@router/modules/routesUtils'
import { permissions } from '@mocks/permissions'
import ConfirmModal from '@components/modals/ConfirmModal'
import { PostalNames } from '@/constants/PortalNames'
import logo from '@/assets/logo_g.svg'
import logoName from '@/assets/logo.webp'
import ReSignIn from './ReSignIn.vue'
import eventBus from '../utils/events'
import { notificationIconSvg } from '@/assets/icons/notificationIcon'
import PrimaryNavigation from '@components/navigation/primary/PrimaryNavigation.vue'
import SecondaryNavigation from '@components/navigation/secondary/SecondaryNavigation.vue'

export default {
  name: 'app',
  components: {
    ConfirmModal,
    ReSignIn,
    PrimaryNavigation,
    SecondaryNavigation
  },
  data () {
    return {
      PostalNames,
      isHideOnUsersPage: false,
      navbar: null,
      permissions: permissions,
      expensesOpen: false,
      notifications: [],
      isExpensesOpen: false,
      fetchNotificationsTimer: null,
      logo,
      logoName,
      bookDemoHref: `${process.env.VUE_APP_LANDING_PAGE}/#section-form`,
      notificationIconSvg,
      isOpen: false,
      menu: [],
      temporarilyNoTransition: false
    }
  },
  mounted () {
    this.setRedirectPath(this.$route.fullPath)
    this.setIsPageInit()
    this.$root.$confirm = this.$refs.confirm
    this.init()

    eventBus.$on('login', () => {
      this.isLogin = true
      this.init()
      this.setIsPageInit()
    })
  },
  beforeDestroy () {
    clearInterval(this.fetchNotificationsTimer)
  },
  watch: {
    $route (to, from) {
      this.setRedirectPath(to.fullPath)
      this.setIsPageInit()
    },
    showSecondaryNavigation (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.temporarilyNoTransition = true

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.temporarilyNoTransition = false
          })
        })
      }
    }
  },
  methods: {
    ...mapActions({
      setIsJiraAuth: 'setIsJiraAuth',
      fetchRoles: 'fetchRoles'
    }),
    toggleMenu (value) {
      this.isOpen = value
    },
    markAllAsRead () {
      this.notifications.forEach((notification) => {
        notification.is_read = true
      })
    },
    setIsPageInit () {
      const isPageInit = localStorage.getItem('is_page_init')
      if (!isPageInit) {
        localStorage.setItem('is_page_init', true)
      }
      setTimeout(() => {
        localStorage.removeItem('is_page_init')
      }, 5000)
    },
    setRedirectPath (currentPath) {
      const isPageInit = localStorage.getItem('is_page_init')
      if (!isPageInit) {
        localStorage.setItem('redirect_url_path', currentPath)
      }
    },
    toggleExpensesShow () {
      this.expensesOpen = !this.expensesOpen
    },
    init () {
      this.setNavbarData()
      if (this.isLogin) {
        this.fetchIsJiraAuth()
        this.fetchNotifications()
        const user = this.getUser
        window.Echo.private(`user.${user.id}`).listen(
          '.App\\Notifications\\NewNotification',
          (e) => {
            this.fetchNotifications()
          }
        )
      }
    },
    setNavbarData () {
      this.menu = [
        {
          name: 'Dashboard',
          route: 'home',
          showItem: this.$can(permissions.ReadAllHome)
        },
        {
          name: 'Shortcuts',
          showItem: this.$can(permissions.ReadAllHome),
          children: [
            {
              name: 'Work schedule',
              route: 'booking-view',
              iconName: 'Schedule_Work schedule',
              showItem: this.$can('read_own-booking_view')
            },
            {
              name: 'Hours tracking report',
              iconName: 'Reports_Hours tracking report',
              route: 'working-time-hours-tracking',
              showItem: this.$can(permissions.ReadOwnLogTimeReports)
            },
            {
              name: 'By people & projects',
              showItem:
                this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                this.$can(permissions.ReadAllFinancesPPReportProfitability),
              route: 'finances-reports-by-people-and-projects'
            },
            {
              name: 'Expenses',
              iconName: 'Finances_Expenses',
              route: 'finances-expenses',
              showItem:
                this.$can(permissions.ReadAllFinancesExpenses) ||
                this.$can(permissions.ReadOwnFinancesExpenses)
            },
            {
              name: 'Invoices',
              iconName: 'Finances_Invoices',
              route: 'finances-invoices',
              showItem: this.$can(permissions.ReadAllFinancesInvoices)
            },
            {
              name: 'Payouts',
              iconName: 'Finances_Payouts',
              route: 'finances-payouts',
              showItem: this.$can(permissions.ReadAllFinancesPayouts)
            },
            { name: 'Available profiles', route: 'available-profiles' },
            {
              name: 'Sales report',
              isGroup: true,
              group: [
                {
                  name: 'Detailed',
                  iconName: 'Reports_Sales report',
                  route: 'finances-sales-report',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability)
                },
                {
                  name: 'Historical',
                  iconName: 'Reports_Sales report',
                  route: 'finances-sales-report-historical',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability)
                }
              ],
              showItem:
                this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                this.$can(permissions.ReadAllFinancesPPReportProfitability)
            },
            {
              name: 'Hours and payments report',
              isGroup: true,
              group: [
                {
                  name: 'Detailed',
                  route: 'finances-reports-hours-and-payments',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability)
                },
                {
                  name: 'Overview',
                  route: 'finances-reports-hours-and-payments-overview',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability)
                }
              ],
              showItem:
                this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                this.$can(permissions.ReadAllFinancesPPReportProfitability)
            },
            {
              name: 'P&L Report',
              isGroup: true,
              showItem: this.$can(
                permissions.ReadAllFinancesReportProfitAndLoss
              ),
              group: [
                {
                  name: 'Detailed',
                  showItem: this.$can(
                    permissions.ReadAllFinancesReportProfitAndLoss
                  ),
                  route: 'finances-reports-profit-and-loss'
                },
                {
                  name: 'Historical',
                  route: 'finances-reports-profit-and-loss-historical',
                  showItem: this.$can(
                    permissions.ReadAllFinancesReportProfitAndLoss
                  )
                }
              ]
            }
          ]
        },
        {
          name: 'Projects',
          route: 'projects',
          showItem: this.$can('read_all-projects')
        },
        {
          name: 'Work schedule',
          showItem:
            this.$can('read_own-booking_management') ||
            this.$can('read_own-booking_view'),
          children: [
            {
              name: 'Schedule',
              route: 'booking-view',
              iconName: 'Schedule_Work schedule',
              showItem: this.$can('read_own-booking_view')
            },
            {
              name: 'Management',
              iconName: 'Schedule_Booking table',
              route: 'booking-managment',
              showItem: this.$can('read_own-booking_management')
            }
          ]
        },
        {
          name: 'KPI',
          iconName: 'Reports_KPI',
          route: 'kpi-report',
          showItem:
            this.$can('read_all-kpi_reports') ||
            this.$can('read_own-kpi_reports')
        },
        {
          name: 'Finances',
          showItem:
            this.$can('read_all-finances_expenses_category') ||
            this.$can('read_own-finances_expenses') ||
            this.$can('read_all-finances_expenses') ||
            this.$can('read_all-finances_clients') ||
            this.$can('read_all-finances_partners') ||
            this.$can('read_own-finances_expenses_category'),
          children: [
            {
              name: 'Report',
              iconName: 'Reports_Financial reports',
              showItem: this.$can(permissions.ReadAllFinancesInvoices),
              children: [
                {
                  name: 'Sales report',
                  iconName: 'Reports_Sales report',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability),
                  children: [
                    {
                      name: 'Detailed',
                      route: 'finances-sales-report'
                    },
                    {
                      name: 'Historical',
                      route: 'finances-sales-report-historical'
                    }
                  ]
                },
                {
                  name: 'Invoices report',
                  iconName: 'Reports_Sales report',
                  showItem: this.$can(permissions.ReadAllFinancesInvoices),
                  route: 'finances-reports-invoices'
                },
                {
                  name: 'Expenses report',
                  iconName: 'Reports_Sales report',
                  showItem: this.$can(permissions.ReadAllFinancesExpenses),
                  route: 'finances-reports-expenses'
                },
                {
                  name: 'P&L report',
                  iconName: 'Reports_Sales report',
                  showItem: this.$can(
                    permissions.ReadAllFinancesReportProfitAndLoss
                  ),
                  children: [
                    {
                      name: 'Detailed',
                      route: 'finances-reports-profit-and-loss'
                    },
                    {
                      name: 'Historical',
                      route: 'finances-reports-profit-and-loss-historical'
                    }
                  ]
                },
                {
                  name: 'By people & projects',
                  iconName: 'Reports_Sales report',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability),
                  route: 'finances-reports-by-people-and-projects'
                },
                {
                  name: 'Hours & payments report',
                  iconName: 'Reports_Sales report',
                  showItem:
                    this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                    this.$can(permissions.ReadAllFinancesPPReportProfitability),
                  children: [
                    {
                      name: 'Detailed',
                      route: 'finances-reports-hours-and-payments'
                    },
                    {
                      name: 'Overview',
                      route: 'finances-reports-hours-and-payments-overview'
                    }
                  ]
                }
              ]
            },
            {
              name: 'Expenses',
              iconName: 'Finances_Expenses',
              showItem:
                this.$can(permissions.ReadAllFinancesExpenses) ||
                this.$can(permissions.ReadOwnFinancesExpenses),
              children: [
                {
                  name: 'Main',
                  route: 'finances-expenses',
                  iconName: 'Finances_Expenses',
                  showItem:
                    this.$can(permissions.ReadAllFinancesExpensesCategory) ||
                    this.$can(permissions.ReadOwnFinancesExpensesCategory)
                },
                {
                  name: 'Categories',
                  route: 'finances-expenses-categories',
                  iconName: 'Finances_Expenses',
                  showItem:
                    this.$can(permissions.ReadAllFinancesExpensesCategory) ||
                    this.$can(permissions.ReadOwnFinancesExpensesCategory)
                }
              ]
            },
            {
              name: 'Invoices',
              iconName: 'Finances_Invoices',
              children: [
                {
                  name: 'Invoices',
                  iconName: 'Finances_Invoices',
                  route: 'finances-invoices',
                  showItem: this.$can(permissions.ReadAllFinancesInvoices)
                },
                {
                  name: 'Specialization items',
                  iconName: 'Finances_Invoices',
                  route: 'finances-invoices-project-specialisations',
                  showItem: this.$can(
                    permissions.ReadAllFinancesProjectSpecialisations
                  )
                }
              ]
            },
            {
              name: 'Bank details',
              iconName: 'Reports_Financial reports',
              children: [
                {
                  name: 'Own',
                  route: 'finances-bank-details',
                  iconName: 'Reports_Financial reports',
                  showItem: this.$can(
                    permissions.ReadAllFinancesOwnBankDetails
                  )
                },
                {
                  name: 'Clients',
                  route: 'finances-bank-details-clients',
                  iconName: 'contacts_clients',
                  showItem: this.$can(
                    permissions.ReadAllFinancesClientBankDetails
                  )
                },
                {
                  name: 'Cards',
                  iconName: 'Reports_Financial reports',
                  route: 'finances-bank-details-cards',
                  showItem: this.$can(
                    permissions.ReadAllFinancesOwnBankDetails
                  )
                },
                {
                  name: 'Contractors',
                  iconName: 'contacts_clients',
                  route: 'finances-bank-details-contractors',
                  showItem: this.$can(
                    permissions.ReadAllFinancesContractorBankDetails
                  )
                },
                {
                  name: 'Partners',
                  iconName: 'contacts_partners',
                  route: 'finances-bank-details-partners',
                  showItem: this.$can(
                    permissions.ReadAllFinancesPartnerBankDetails
                  )
                }
              ]
            },
            {
              name: 'Clients',
              iconName: 'contacts_clients',
              route: 'finances-clients',
              showItem: this.$can('read_all-finances_clients')
            },
            {
              name: 'Partners',
              iconName: 'contacts_partners',
              route: 'finances-partners',
              showItem: this.$can('read_all-finances_partners')
            },
            {
              name: 'Tax types',
              iconName: 'Tenant settings_Tax types',
              route: 'finances-tax-types',
              showItem: this.$can('read_all-finances_tax_types')
            },
            {
              name: 'Monthly compensations',
              route: 'finances-compensations',
              iconName: 'Tenant settings_Tax types',
              showItem: this.$can('read_all-finances_compensations')
            },
            {
              name: 'Payouts',
              iconName: 'Finances_Payouts',
              route: 'finances-payouts',
              showItem: this.$can(permissions.ReadAllFinancesPayouts)
            },
            {
              name: 'Sales channels',
              iconName: 'Tenant settings_Sales channels',
              route: 'finances-sales-channels',
              showItem:
                this.$can(permissions.ReadAllFinancesPPReportMoney) ||
                this.$can(permissions.ReadAllFinancesPPReportProfitability)
            }
          ]
        },
        {
          name: 'Work time',
          showItem:
            this.$can(permissions.ReadOwnLogTimeReports) ||
            this.$can(permissions.UpdateAllLogTimeReports) ||
            this.$can(permissions.ReadOwnLogTimeReports) ||
            this.$can(permissions.ReadOwnLogTimeReports) ||
            this.$can('read_all-time_offs_settings'),
          children: [
            {
              name: 'Log time report',
              iconName: 'Reports_Log time report',
              route: 'working-time',
              showItem: this.$can(permissions.ReadOwnLogTimeReports)
            },
            {
              name: 'Hours tracking report',
              route: 'working-time-hours-tracking',
              iconName: 'Reports_Hours tracking report',
              showItem: this.$can(permissions.ReadOwnLogTimeReports)
            },
            {
              name: 'Time off report',
              iconName: 'Reports_Time off report',
              showItem: this.$can(permissions.ReadOwnLogTimeReports),
              children: [
                {
                  name: 'Detailed',
                  route: 'time-off-report',
                  also: 'time-off-report-id'
                },
                {
                  name: 'Detailed',
                  route: 'time-off-report-id',
                  also: 'time-off-report',
                  hidden: true
                },
                {
                  name: 'Overview',
                  route: 'time-off-report-overview'
                }
              ]
            },
            {
              name: 'Time off settings',
              iconName: 'Tenant settings_Time Off Settings',
              route: 'time-offs-settings',
              showItem: this.$can('read_all-time_offs_settings')
            }
          ]
        },
        {
          name: 'Backlog',
          route: 'backlog-time-report',
          showItem:
            this.$can('read_own-backlog_reports') ||
            this.$can('read_own-backlog_history')
        },
        {
          name: 'Misc',
          showItem:
            this.$can('read_all-permission') ||
            this.$can('read_all-not_estimated') ||
            this.$can('create-skills') ||
            this.$can('read_all-system_operations'),
          children: [
            {
              name: 'System operations',
              iconName: 'Tenant settings_Permissions table',
              route: 'system-operations',
              showItem: this.$can('read_all-system_operations')
            },
            {
              name: 'Permissions',
              iconName: 'Tenant settings_Permissions table',
              route: 'permission',
              showItem: this.$can('read_all-permission')
            },
            {
              name: 'Not estimated',
              route: 'not-estimated',
              iconName: 'Tenant settings_Holidays & schedule',
              showItem: this.$can('read_all-not_estimated')
            },
            {
              name: 'Not budgeted',
              route: 'not-budget',
              iconName: 'Tenant settings_Holidays & schedule',
              showItem: this.$can('read_all-not_estimated')
            },
            {
              name: 'Skills',
              iconName: 'Tenant settings_Skills',
              route: 'skills',
              showItem: this.$can('create-skills')
            },
            {
              name: 'Holidays',
              route: 'holidays',
              iconName: 'Tenant settings_Holidays & schedule',
              showItem: this.$can('read_all-holidays')
            },
            {
              name: 'Backlog',
              iconName: 'Tenant settings_Holidays & schedule',
              route: 'backlog-not-done-and-estimated',
              showItem: this.$can('read_own-backlog_reports')
            }
          ]
        },
        {
          name: 'Notifications',
          showItem: this.$can(permissions.ReadAllHome),
          iconName: 'contacts_partners',
          children: [
            {
              name: 'Telegram',
              showItem: this.$can(permissions.ReadAllHome),
              iconName: 'contacts_partners',
              children: [
                {
                  name: 'Partners',
                  route: 'notifications-telegram-partners',
                  showItem: this.$can(permissions.ReadAllHome),
                  iconName: 'contacts_partners'
                },
                {
                  name: 'Contractors',
                  route: 'notifications-telegram-contractors',
                  showItem: this.$can(permissions.ReadAllHome),
                  iconName: 'contacts_partners'
                },
                {
                  name: 'Campaigns for partners',
                  route: 'notifications-telegram-campaigns-for-partners',
                  showItem: this.$can(permissions.ReadAllHome),
                  iconName: 'contacts_partners'
                },
                {
                  name: 'Campaigns for contractors',
                  route: 'notifications-telegram-campaigns-for-contractors',
                  showItem: this.$can(permissions.ReadAllHome),
                  iconName: 'contacts_partners'
                }
              ]
            }
          ]
        }
      ]
    },
    toggleShowSidebar () {
      this.$store.dispatch('toggleSidebar', !this.getShowSidebar)
    },
    logOut () {
      this.$api.auth.logout()
    },
    async fetchNotifications () {
      const response = await this.axios({
        method: 'get',
        url: '/api/user-notifications',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
      this.notifications = response.data
    },
    readNotification (index) {
      const id = this.notifications[index].id
      this.notifications[index].is_read = true
      this.axios({
        method: 'get',
        url: '/api/user-notifications/read/' + id,
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then((response) => {
          window.location.href = response.data.redirect_url
        })
        .catch((err) => {
          this.errorNotifications(err)
        })
    },
    isHideHeader () {
      if (this.$router.history.current.name === 'users') {
        this.isHideOnUsersPage = true
      } else {
        this.isHideOnUsersPage = false
      }
    },
    findTopParent (menu, targetName) {
      function helper (items, targetName, parent = null, topParent = null) {
        for (const item of items) {
          if (item.route === targetName || item.also === targetName) {
            return topParent || item
          }

          if (item.children) {
            const found = helper(
              item.children,
              targetName,
              item,
              topParent || item
            )
            if (found) return found
          }
        }
        return null
      }

      return helper(menu, targetName)
    }
  },
  computed: {
    ...mapGetters({
      dateFormat: 'dateFormat',
      getCurrentUserRole: 'getCurrentUserRole',
      isActive: 'isActive',
      getShowSidebar: 'getShowSidebar'
    }),
    showSecondaryNavigation () {
      const topParent = this.findTopParent(this.menu, this.$route.name)
      return topParent?.children
    },
    isSigninRoute () {
      return [this.ROUTES.SIGN_IN.path].includes(this.$route.path)
    },
    shortcutsDropdown () {
      if (
        !this.navbar ||
        !this.navbar.Shortcuts ||
        !this.navbar.Shortcuts.showItem
      ) {
        return null
      }

      const filteredShortcuts = Object.keys(
        this.navbar.Shortcuts.children || {}
      )
        .filter((key) => {
          const child = this.navbar.Shortcuts.children[key]
          return child && child.showItem
        })
        .map((key) => this.navbar.Shortcuts.children[key])

      return {
        ...this.navbar.Shortcuts,
        children: filteredShortcuts
      }
    },
    financesDropdown () {
      if (
        !this.navbar ||
        !this.navbar.Finances ||
        !this.navbar.Finances.showItem
      ) {
        return null
      }

      const financesChildren = Object.keys(this.navbar.Finances.children || {})
        .filter((key) => {
          const child = this.navbar.Finances.children[key]
          return (
            child &&
            child.showItem &&
            ![
              'Partners',
              'TaxTypes',
              'Payouts',
              'SalesChannels',
              'Expenses',
              'FinancesReports'
            ].includes(key)
          )
        })
        .map((key) => {
          const child = this.navbar.Finances.children[key]
          if (child.label === 'Compensations') {
            child.label = 'Monthly Compensations'
          }
          return child
        })

      return {
        ...this.navbar.Finances,
        children: financesChildren
      }
    },
    unreadNotifications () {
      return this.notifications.filter((notification) => !notification.is_read)
    },
    isStandalonePage () {
      const routeName = this.$route.name
      return this.standalonePages.includes(routeName)
    },
    isPublicPage () {
      return isPublicPage(this.$route.name)
    },
    isUseSignInSignUpLayout () {
      return isSignInSignUpPage(this.$route.name)
    },
    isShowNavbarLinks () {
      // Show navigation links only when user is logged in and the page is no using SignInSignUpLayout.
      // Pages that use SignInSignUpLayout are related to the Sign-In/Sign-Up flow and should not display main site navigation
      return this.isLogin && !this.isUseSignInSignUpLayout
    }
  },

  async created () {
    document.title = process.env.VUE_APP_TITLE ?? 'Easy Agency'
    if (localStorage.getItem('access_token')) {
      await this.fetchRoles()
      await this.$api.auth.authUser()
    }
    this.axios.interceptors.response.use(undefined, (err) => {
      return new Promise((resolve, reject) => {
        if (err.response?.status === 401) {
          // if you ever get an unauthorized, logout the user
          localStorage.removeItem('access_token')
          this.isLogin = false
          throw err
          // you can also redirect to /login if needed !
        } else {
          throw err
        }
      })
    })
    this.axios.interceptors.request.use(undefined)

    this.isHideHeader()

    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
    )
    document.head.appendChild(recaptchaScript)
  },
  updated () {
    this.isLogin = !!localStorage.getItem('access_token')
    this.isHideHeader()
  }
}
</script>

<style
  src="../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"
></style>

<style lang="scss">
@import "../sass/app.scss";

.notification-popover .popover-body {
  max-height: 350px;
  overflow: auto;
}

.content {
  position: relative;
}

.notification-popover {
  top: 25px !important;
  left: 200px !important;
  border: none !important;

  .arrow {
    display: none !important;
  }

  .no-notifications {
    padding: 0.5rem 0.75rem;
  }

  h3.popover-header {
    font-size: 18px;
    background: #fff;
    border: none;
    padding: 8px;
    font-family: $font-family-sans-serif;
    color: $fontColorBase;
    button {
      background-color: #fff;
      color: $fontColorAccent;
      font-size: 13px;
      font-weight: 400;
      border: none;
      padding-right: 0;
    }
  }
  div.popover-header {
    background-color: #fff;
    border: none;
    display: flex;
    padding: 0 0.25rem;
    justify-content: space-between;
    align-items: center;
  }
  .popover-body {
    padding: 0;
  }
  .notification-item {
    padding: 0.5rem 0.75rem;
    line-height: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    border-top: 0;
    border-right: 0;
    border-left: 0;
    font-family: $font-family-sans-serif;
    background-color: #ccdffd59;
    font-weight: 400 !important;
    position: relative;
    color: $fontColorBase;
    &:last-child {
      border-bottom: 0;
    }

    .list-item-el {
      width: 8px;
      height: 8px;
      border-radius: 100%;
      display: block;
      position: absolute;
      right: 10px;
      top: 10px;
      background-color: $fontColorAccent;
    }
  }
  .notification-item.is-read {
    background-color: #fff;

    .list-item-el {
      display: none;
    }
  }
}

.notification-block-menu .notification-item {
  font-weight: 700;
}

.notification-block-menu .notification-item.is-read,
.notification-block-menu .notification-item:hover {
  font-weight: normal;
}

.navbar-details {
  .dropdown-toggle {
    width: auto !important;
    height: auto !important;
  }
}

.bell-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #0052cc !important;
}

.user-container {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .navbar-user__position {
    font-size: 11px;
    color: #7489a9;
  }
}

.auth-block {
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.5);

  .tabs {
    width: 500px;
    margin: 10px auto;
    padding: 0px 0px 10px 0px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 1em;
    border: 1px solid #eeeeee;
  }
}
</style>

<style lang="scss" scoped>
.text-logo {
  color: #1b1d2c;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  margin-left: 10px;
}

.onUser {
  background: #ff0000;
}

.header-link-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 0;
}

.navbar-links {
  display: flex;
  align-items: center;
}

.navbar-link {
  margin-right: 1.6rem;
  white-space: nowrap;
  color: $fontColorBase;
  font-size: 15px;
  font-weight: 400;
  text-decoration: none;

  :global(.btn) {
    font-size: inherit;
  }
}

.navbar-link.active {
  font-weight: 700;
  color: $iconColorAccent;
}

.sign-in-content {
  display: flex;
  flex-direction: column;

  .content {
    flex-grow: 1;
    display: flex;
    padding: 0;
  }
}

.navbar-sign-in {
  position: absolute;
  z-index: 1;
  width: 100%;
  padding: 20px 80px 20px 30px;
  background-color: transparent;

  .sign-in-buttons {
    .btn {
      display: initial;
      min-width: 150px;
      border-radius: 12px;
      padding: 14px 28px;
      font-family: $font-family-sans-serif;
      font-size: 14px;
      line-height: 18px;
      font-weight: 700;
      text-transform: uppercase;
    }

    .btn + .btn {
      margin-left: 30px;
    }

    .btn.btn-light {
      border: 1px solid $fontColorAccent;
      color: $fontColorAccent;
    }
  }
}

.content {
  padding: 40px;
  flex-grow: 1;
  padding: $contentPadding;
  background-color: $bgColorBase;
}

.layout {
  transition: all 0.2s;
}

.no-transition {
  transition: none !important;
}
</style>
